import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";

@Component({
  moduleId: module.id,
  selector: 'site-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent {

  film: FilmModel;

  constructor(private filmService:FilmService, private personService:PersonService, private contentService:ContentService)
  {
  }

  recentWrittenReviewList: ContentModel[];
  recentVideoReviewList: ContentModel[];
  recentCriticalEssayList: ContentModel[];
  recentTheoreticalEssayList: ContentModel[];
  recentVideoList: ContentModel[];
  recentNewsList: ContentModel[];

  recentWrittenReviewImages: ContentModel[];
  recentVideoReviewImages: ContentModel[];
  recentCriticalEssayImages: ContentModel[];
  recentTheoreticalEssayImages: ContentModel[];
  recentVideoImages: ContentModel[];
  recentNewsImages: ContentModel[];

  contentInfo: ContentModel;
  contributorList: string[];

  ngOnInit(): void{
    
    this.getRecentWrittenReviews().subscribe(w =>{
      this.recentWrittenReviewList = w;
    });
    this.getRecentVideoReviews().subscribe(r =>{
      this.recentVideoReviewList = r;
    });
    this.getRecentCriticalEssays().subscribe(c =>{
      this.recentCriticalEssayList = c;
    });
    this.getRecentTheoreticalEssays().subscribe(t =>{
      this.recentTheoreticalEssayList = t;
    });
    this.getRecentVideos().subscribe(v =>{
      this.recentVideoList = v;
    });
    this.getRecentNews().subscribe(n =>{
      this.recentNewsList = n;
    });

    this.getRecentWrittenReviewsImages().subscribe(wri =>{
      this.recentWrittenReviewImages = wri;
    });
    this.getRecentVideoReviewsImages().subscribe(vri =>{
      this.recentVideoReviewImages = vri;
    });
    this.getRecentCriticalEssaysImages().subscribe(ci =>{
      this.recentCriticalEssayImages = ci;
    });
    this.getRecentTheoreticalEssaysImages().subscribe(ti =>{
      this.recentTheoreticalEssayImages = ti;
    });
    this.getRecentVideosImages().subscribe(vi =>{
      this.recentVideoImages = vi;
    });
    this.getRecentNewsImages().subscribe(ni =>{
      this.recentNewsImages = ni;
    });


    // this.getVideoReviewList().subscribe(v =>{
    //   this.videoReviewList = v;
    // });
    // console.log(this.content);
  }

  private getFilm(index: number): Observable<FilmModel>
  {
    return this.filmService.getFilm(index).map((v,i)=>v);
  }

  //List stuff
  private getRecentWrittenReviews(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentList("Written Film Review", 3).map((v,i)=>v);
  }

  private getRecentVideoReviews(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentList("Video Film Review", 3).map((v,i)=>v);
  }

  private getRecentCriticalEssays(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentList("Critical Essay", 3).map((v,i)=>v);
  }

  private getRecentTheoreticalEssays(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentList("Theoretical Essay", 3).map((v,i)=>v);
  }

  private getRecentVideos(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentList("Video Essay", 3).map((v,i)=>v);
  }

  private getRecentNews(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentList("News Article", 3).map((v,i)=>v);
  }


  private getRecentWrittenReviewsImages(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentImages("Written Film Review", 3).map((v,i)=>v);
  }

  private getRecentVideoReviewsImages(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentImages("Video Film Review", 3).map((v,i)=>v);
  }

  private getRecentCriticalEssaysImages(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentImages("Critical Essay", 3).map((v,i)=>v);
  }

  private getRecentTheoreticalEssaysImages(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentImages("Theoretical Essay", 3).map((v,i)=>v);
  }

  private getRecentNewsImages(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentImages("News Article", 3).map((v,i)=>v);
  }

  private getRecentVideosImages(): Observable<ContentModel[]>
  {
    return this.contentService.getRecentContentImages("Video Essay", 3).map((v,i)=>v);
  }

  private formatReleaseDate(): string 
  {
    let monthNames: string[] = 
    [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
    ];
    let day: number = this.film.releaseDate.getDate();
    let monthIndex: number = this.film.releaseDate.getMonth();
    let year: number = this.film.releaseDate.getFullYear();

    return monthNames[monthIndex] + ' ' + day + ', ' + year;
  }

  private formatStars(): string
  {
    let numStars: number = this.film.paulEntertainment;
    let entertainmentStars: string = "";

    for (let i:number = 1; i<= 4; i++)
    {
      if (i<=numStars)
      {
        entertainmentStars += "&#9733; "
      }
      else
      {
        entertainmentStars += "&#9734; "
      }
    }
    return entertainmentStars;
  }

  person: PersonModel;

  private getPerson(index: number): Observable<PersonModel>
  {
    return this.personService.getPerson(index).map((v,i)=>v);
  }

  private getDirector(): string
  {
    let directors:string = "";
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleName === "Director")
        {
          let directorName:string = this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName;
          directors += directorName + "<br/>";
        }
      }
    }
    return directors.substring(0,directors.length - 5);
  }

  private getStars(): string[]
  {
    let stars: string[] = new Array();
    
    for (let i:number = 0; i<this.film.filmmakers.length; i++)
    {
      for (let t:number = 0; t<this.film.filmmakers[i].filmmakerRoles.length; t++)
      {
        if (this.film.filmmakers[i].filmmakerRoles[t].roleType === "Starring")
        {
          let starName:string = "";
          stars.push(this.film.filmmakers[i].personFirstName + " " + this.film.filmmakers[i].personLastName);
          stars.push(this.film.filmmakers[i].filmmakerRoles[t].roleName);
        }
      }
    }
    return stars;
  }

  content: ContentModel;  

  private getContent(index: number): Observable<ContentModel>
  {
    return this.contentService.getContent(index).map((v,i)=>v);
  }

  private formatPublishDate(): string 
  {
    let monthNames: string[] = 
    [
    "January", "February", "March",
    "April", "May", "June", "July",
    "August", "September", "October",
    "November", "December"
    ];
    let day: number = this.content.publishDate.getDate();
    let monthIndex: number = this.content.publishDate.getMonth();
    let year: number = this.content.publishDate.getFullYear();

    return monthNames[monthIndex] + ' ' + day + ', ' + year;
  }

  private getContributors(): string[]
  {
    // let contributorListTemp: string[];
    this.contributorList = Array();
    for(let i: number = 0; i<this.content.contributors.length; i++)
    {
      console.log(this.content.contributors[i].displayName);
      this.contributorList.push(this.content.contributors[i].displayName);
    }
    console.log(this.contributorList);
    return this.contributorList;
  }

  private getNewReview(): ContentModel
  {
    return this.content[1];
  }

 }


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/index/index.component.ts